export const vkontaktePublicPageURLRegExp =
  /(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?vk\.com\/(?:public|club|event)?(\d{1,})/;
export const vkontakteURLRegExp =
  /(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?vk\.com\/([^\s/?#]+)/;
